webpackJsonp([276150767547794],{

/***/ "./node_modules/bricks.js/dist/bricks.js":
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Bricks = factory());
	}(this, (function () { 'use strict';
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var knot = function knot() {
	  var extended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var events = Object.create(null);
	
	  function on(name, handler) {
	    events[name] = events[name] || [];
	    events[name].push(handler);
	    return this;
	  }
	
	  function once(name, handler) {
	    handler._once = true;
	    on(name, handler);
	    return this;
	  }
	
	  function off(name) {
	    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    handler ? events[name].splice(events[name].indexOf(handler), 1) : delete events[name];
	
	    return this;
	  }
	
	  function emit(name) {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    // cache the events, to avoid consequences of mutation
	    var cache = events[name] && events[name].slice();
	
	    // only fire handlers if they exist
	    cache && cache.forEach(function (handler) {
	      // remove handlers added with 'once'
	      handler._once && off(name, handler);
	
	      // set 'this' context, pass args to handlers
	      handler.apply(_this, args);
	    });
	
	    return this;
	  }
	
	  return _extends({}, extended, {
	
	    on: on,
	    once: once,
	    off: off,
	    emit: emit
	  });
	};
	
	var bricks = function bricks() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // privates
	
	  var persist = void 0; // packing new elements, or all elements?
	  var ticking = void 0; // for debounced resize
	
	  var sizeIndex = void 0;
	  var sizeDetail = void 0;
	
	  var columnTarget = void 0;
	  var columnHeights = void 0;
	
	  var nodeTop = void 0;
	  var nodeLeft = void 0;
	  var nodeWidth = void 0;
	  var nodeHeight = void 0;
	
	  var nodes = void 0;
	  var nodesWidths = void 0;
	  var nodesHeights = void 0;
	
	  // resolve options
	
	  var packed = options.packed.indexOf('data-') === 0 ? options.packed : 'data-' + options.packed;
	  var sizes = options.sizes.slice().reverse();
	  var position = options.position !== false;
	
	  var container = options.container.nodeType ? options.container : document.querySelector(options.container);
	
	  var selectors = {
	    all: function all() {
	      return toArray(container.children);
	    },
	    new: function _new() {
	      return toArray(container.children).filter(function (node) {
	        return !node.hasAttribute('' + packed);
	      });
	    }
	  };
	
	  // series
	
	  var setup = [setSizeIndex, setSizeDetail, setColumns];
	
	  var run = [setNodes, setNodesDimensions, setNodesStyles, setContainerStyles];
	
	  // instance
	
	  var instance = knot({
	    pack: pack,
	    update: update,
	    resize: resize
	  });
	
	  return instance;
	
	  // general helpers
	
	  function runSeries(functions) {
	    functions.forEach(function (func) {
	      return func();
	    });
	  }
	
	  // array helpers
	
	  function toArray(input) {
	    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
	
	    return Array.prototype.slice.call(input);
	  }
	
	  function fillArray(length) {
	    return Array.apply(null, Array(length)).map(function () {
	      return 0;
	    });
	  }
	
	  // size helpers
	
	  function getSizeIndex() {
	    // find index of widest matching media query
	    return sizes.map(function (size) {
	      return size.mq && window.matchMedia('(min-width: ' + size.mq + ')').matches;
	    }).indexOf(true);
	  }
	
	  function setSizeIndex() {
	    sizeIndex = getSizeIndex();
	  }
	
	  function setSizeDetail() {
	    // if no media queries matched, use the base case
	    sizeDetail = sizeIndex === -1 ? sizes[sizes.length - 1] : sizes[sizeIndex];
	  }
	
	  // column helpers
	
	  function setColumns() {
	    columnHeights = fillArray(sizeDetail.columns);
	  }
	
	  // node helpers
	
	  function setNodes() {
	    nodes = selectors[persist ? 'new' : 'all']();
	  }
	
	  function setNodesDimensions() {
	    // exit if empty container
	    if (nodes.length === 0) {
	      return;
	    }
	
	    nodesWidths = nodes.map(function (element) {
	      return element.clientWidth;
	    });
	    nodesHeights = nodes.map(function (element) {
	      return element.clientHeight;
	    });
	  }
	
	  function setNodesStyles() {
	    nodes.forEach(function (element, index) {
	      columnTarget = columnHeights.indexOf(Math.min.apply(Math, columnHeights));
	
	      element.style.position = 'absolute';
	
	      nodeTop = columnHeights[columnTarget] + 'px';
	      nodeLeft = columnTarget * nodesWidths[index] + columnTarget * sizeDetail.gutter + 'px';
	
	      // support positioned elements (default) or transformed elements
	      if (position) {
	        element.style.top = nodeTop;
	        element.style.left = nodeLeft;
	      } else {
	        element.style.transform = 'translate3d(' + nodeLeft + ', ' + nodeTop + ', 0)';
	      }
	
	      element.setAttribute(packed, '');
	
	      // ignore nodes with no width and/or height
	      nodeWidth = nodesWidths[index];
	      nodeHeight = nodesHeights[index];
	
	      if (nodeWidth && nodeHeight) {
	        columnHeights[columnTarget] += nodeHeight + sizeDetail.gutter;
	      }
	    });
	  }
	
	  // container helpers
	
	  function setContainerStyles() {
	    container.style.position = 'relative';
	    container.style.width = sizeDetail.columns * nodeWidth + (sizeDetail.columns - 1) * sizeDetail.gutter + 'px';
	    container.style.height = Math.max.apply(Math, columnHeights) - sizeDetail.gutter + 'px';
	  }
	
	  // resize helpers
	
	  function resizeFrame() {
	    if (!ticking) {
	      window.requestAnimationFrame(resizeHandler);
	      ticking = true;
	    }
	  }
	
	  function resizeHandler() {
	    if (sizeIndex !== getSizeIndex()) {
	      pack();
	      instance.emit('resize', sizeDetail);
	    }
	
	    ticking = false;
	  }
	
	  // API
	
	  function pack() {
	    persist = false;
	    runSeries(setup.concat(run));
	
	    return instance.emit('pack');
	  }
	
	  function update() {
	    persist = true;
	    runSeries(run);
	
	    return instance.emit('update');
	  }
	
	  function resize() {
	    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var action = flag ? 'addEventListener' : 'removeEventListener';
	
	    window[action]('resize', resizeFrame);
	
	    return instance;
	  }
	};
	
	return bricks;
	
	})));


/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ "./node_modules/react-scrollbar/dist/no-css.js":
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__("./node_modules/react/react.js")):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ScrollArea=t(require("react")):e.ScrollArea=t(e.React)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=n(11),i=o(r);t.default=i.default},function(t,n){t.exports=e},function(e,t,n){(function(t){(function(){var n,o,r;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-r)/1e6},o=t.hrtime,n=function(){var e;return e=o(),1e9*e[0]+e[1]},r=n()):Date.now?(e.exports=function(){return Date.now()-r},r=Date.now()):(e.exports=function(){return(new Date).getTime()-r},r=(new Date).getTime())}).call(this)}).call(t,n(15))},function(e,t,n){(function(t){for(var o=n(2),r="undefined"==typeof window?t:window,i=["moz","webkit"],a="AnimationFrame",l=r["request"+a],s=r["cancel"+a]||r["cancelRequest"+a],u=0;!l&&u<i.length;u++)l=r[i[u]+"Request"+a],s=r[i[u]+"Cancel"+a]||r[i[u]+"CancelRequest"+a];if(!l||!s){var c=0,f=0,p=[],d=1e3/60;l=function(e){if(0===p.length){var t=o(),n=Math.max(0,d-(t-c));c=n+t,setTimeout(function(){var e=p.slice(0);p.length=0;for(var t=0;t<e.length;t++)if(!e[t].cancelled)try{e[t].callback(c)}catch(e){setTimeout(function(){throw e},0)}},Math.round(n))}return p.push({handle:++f,callback:e,cancelled:!1}),f},s=function(e){for(var t=0;t<p.length;t++)p[t].handle===e&&(p[t].cancelled=!0)}}e.exports=function(e){return l.call(r,e)},e.exports.cancel=function(){s.apply(r,arguments)},e.exports.polyfill=function(){r.requestAnimationFrame=l,r.cancelAnimationFrame=s}}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=0);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var o in t)if(Object.prototype.hasOwnProperty.call(t,o)){if(0!==n[o])return!1;var r="number"==typeof t[o]?t[o]:t[o].val;if(e[o]!==r)return!1}return!0}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n,r,i,a,l){var s=-i*(t-r),u=-a*n,c=s+u,f=n+c*e,p=t+f*e;return Math.abs(f)<l&&Math.abs(p-r)<l?(o[0]=r,o[1]=0,o):(o[0]=p,o[1]=f,o)}t.__esModule=!0,t.default=n;var o=[0,0];e.exports=t.default},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]="number"==typeof e[n]?e[n]:e[n].val);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e){return p?f.default.findDOMNode(e):e}function i(){d||p||(d=!0,console.error("With React 0.14 and later versions, you no longer need to wrap <ScrollArea> child into a function."))}function a(){!d&&p&&(d=!0,console.error("With React 0.13, you need to wrap <ScrollArea> child into a function."))}function l(e){return e<0?0:e}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(e){return e},n={};for(var o in e)e.hasOwnProperty(o)&&(n[o]=t(e[o]));return n}function u(e){var t=e.version;if("string"!=typeof t)return!0;var n=t.split("."),o=parseInt(n[0],10),r=parseInt(n[1],10);return 0===o&&13===r}Object.defineProperty(t,"__esModule",{value:!0}),t.findDOMNode=r,t.warnAboutFunctionChild=i,t.warnAboutElementChild=a,t.positiveOrZero=l,t.modifyObjValues=s,t.isReact13=u;var c=n(1),f=o(c),p=u(f.default),d=!1},function(e,t){"use strict";t.__esModule=!0,t.default={noWobble:{stiffness:170,damping:26},gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}},e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var r=n(16);t.Motion=o(r);var i=n(17);t.StaggeredMotion=o(i);var a=n(18);t.TransitionMotion=o(a);var l=n(21);t.spring=o(l);var s=n(9);t.presets=o(s);var u=n(20);t.reorderKeys=o(u)},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),c=n(1),f=o(c),p=n(12),d=o(p),h=n(8),y=n(14),m=o(y),v=n(10),S={wheel:"wheel",api:"api",touch:"touch",touchEnd:"touchEnd",mousemove:"mousemove",keyPress:"keypress"},P=function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={topPosition:0,leftPosition:0,realHeight:0,containerHeight:0,realWidth:0,containerWidth:0},n.scrollArea={refresh:function(){n.setSizesToState()},scrollTop:function(){n.scrollTop()},scrollBottom:function(){n.scrollBottom()},scrollYTo:function(e){n.scrollYTo(e)},scrollLeft:function(){n.scrollLeft()},scrollRight:function(){n.scrollRight()},scrollXTo:function(e){n.scrollXTo(e)}},n.evntsPreviousValues={clientX:0,clientY:0,deltaX:0,deltaY:0},n.bindedHandleWindowResize=n.handleWindowResize.bind(n),n}return a(t,e),u(t,[{key:"getChildContext",value:function(){return{scrollArea:this.scrollArea}}},{key:"componentDidMount",value:function(){this.props.contentWindow&&this.props.contentWindow.addEventListener("resize",this.bindedHandleWindowResize),this.lineHeightPx=(0,m.default)((0,h.findDOMNode)(this.content)),this.setSizesToState()}},{key:"componentWillUnmount",value:function(){this.props.contentWindow&&this.props.contentWindow.removeEventListener("resize",this.bindedHandleWindowResize)}},{key:"componentDidUpdate",value:function(){this.setSizesToState()}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,o=t.className,r=t.contentClassName,i=t.ownerDocument,a=this.props.smoothScrolling&&(this.state.eventType===S.wheel||this.state.eventType===S.api||this.state.eventType===S.touchEnd||this.state.eventType===S.keyPress),l=this.canScrollY()?f.default.createElement(d.default,{ownerDocument:i,realSize:this.state.realHeight,containerSize:this.state.containerHeight,position:this.state.topPosition,onMove:this.handleScrollbarMove.bind(this),onPositionChange:this.handleScrollbarYPositionChange.bind(this),containerStyle:this.props.verticalContainerStyle,scrollbarStyle:this.props.verticalScrollbarStyle,smoothScrolling:a,minScrollSize:this.props.minScrollSize,onFocus:this.focusContent.bind(this),type:"vertical"}):null,u=this.canScrollX()?f.default.createElement(d.default,{ownerDocument:i,realSize:this.state.realWidth,containerSize:this.state.containerWidth,position:this.state.leftPosition,onMove:this.handleScrollbarMove.bind(this),onPositionChange:this.handleScrollbarXPositionChange.bind(this),containerStyle:this.props.horizontalContainerStyle,scrollbarStyle:this.props.horizontalScrollbarStyle,smoothScrolling:a,minScrollSize:this.props.minScrollSize,onFocus:this.focusContent.bind(this),type:"horizontal"}):null;"function"==typeof n?((0,h.warnAboutFunctionChild)(),n=n()):(0,h.warnAboutElementChild)();var c="scrollarea "+(o||""),p="scrollarea-content "+(r||""),y={marginTop:-this.state.topPosition,marginLeft:-this.state.leftPosition},m=a?(0,h.modifyObjValues)(y,function(e){return(0,v.spring)(e)}):y;return f.default.createElement(v.Motion,{style:m},function(t){return f.default.createElement("div",{ref:function(t){return e.wrapper=t},className:c,style:e.props.style,onWheel:e.handleWheel.bind(e)},f.default.createElement("div",{ref:function(t){return e.content=t},style:s({},e.props.contentStyle,t),className:p,onTouchStart:e.handleTouchStart.bind(e),onTouchMove:e.handleTouchMove.bind(e),onTouchEnd:e.handleTouchEnd.bind(e),onKeyDown:e.handleKeyDown.bind(e),tabIndex:e.props.focusableTabIndex},n),l,u)})}},{key:"setStateFromEvent",value:function(e,t){this.props.onScroll&&this.props.onScroll(e),this.setState(s({},e,{eventType:t}))}},{key:"handleTouchStart",value:function(e){var t=e.touches;if(1===t.length){var n=t[0],o=n.clientX,r=n.clientY;this.eventPreviousValues=s({},this.eventPreviousValues,{clientY:r,clientX:o,timestamp:Date.now()})}}},{key:"handleTouchMove",value:function(e){e.preventDefault(),e.stopPropagation();var t=e.touches;if(1===t.length){var n=t[0],o=n.clientX,r=n.clientY,i=this.eventPreviousValues.clientY-r,a=this.eventPreviousValues.clientX-o;this.eventPreviousValues=s({},this.eventPreviousValues,{deltaY:i,deltaX:a,clientY:r,clientX:o,timestamp:Date.now()}),this.setStateFromEvent(this.composeNewState(-a,-i))}}},{key:"handleTouchEnd",value:function(e){var t=this.eventPreviousValues,n=t.deltaX,o=t.deltaY,r=t.timestamp;"undefined"==typeof n&&(n=0),"undefined"==typeof o&&(o=0),Date.now()-r<200&&this.setStateFromEvent(this.composeNewState(10*-n,10*-o),S.touchEnd),this.eventPreviousValues=s({},this.eventPreviousValues,{deltaY:0,deltaX:0})}},{key:"handleScrollbarMove",value:function(e,t){this.setStateFromEvent(this.composeNewState(t,e))}},{key:"handleScrollbarXPositionChange",value:function(e){this.scrollXTo(e)}},{key:"handleScrollbarYPositionChange",value:function(e){this.scrollYTo(e)}},{key:"handleWheel",value:function(e){var t=e.deltaY,n=e.deltaX;if(this.props.swapWheelAxes){var o=[n,t];t=o[0],n=o[1]}1===e.deltaMode&&(t*=this.lineHeightPx,n*=this.lineHeightPx),t*=this.props.speed,n*=this.props.speed;var r=this.composeNewState(-n,-t);(r.topPosition&&this.state.topPosition!==r.topPosition||r.leftPosition&&this.state.leftPosition!==r.leftPosition||this.props.stopScrollPropagation)&&(e.preventDefault(),e.stopPropagation()),this.setStateFromEvent(r,S.wheel),this.focusContent()}},{key:"handleKeyDown",value:function(e){if("input"!==e.target.tagName.toLowerCase()){var t=0,n=0,o=this.lineHeightPx?this.lineHeightPx:10;switch(e.keyCode){case 33:t=this.state.containerHeight-o;break;case 34:t=-this.state.containerHeight+o;break;case 37:n=o;break;case 38:t=o;break;case 39:n=-o;break;case 40:t=-o}if(0!==t||0!==n){var r=this.composeNewState(n,t);e.preventDefault(),e.stopPropagation(),this.setStateFromEvent(r,S.keyPress)}}}},{key:"handleWindowResize",value:function(){var e=this.computeSizes();e=this.getModifiedPositionsIfNeeded(e),this.setStateFromEvent(e)}},{key:"composeNewState",value:function(e,t){var n=this.computeSizes();return this.canScrollY(n)?n.topPosition=this.computeTopPosition(t,n):n.topPosition=0,this.canScrollX(n)&&(n.leftPosition=this.computeLeftPosition(e,n)),n}},{key:"computeTopPosition",value:function(e,t){var n=this.state.topPosition-e;return this.normalizeTopPosition(n,t)}},{key:"computeLeftPosition",value:function(e,t){var n=this.state.leftPosition-e;return this.normalizeLeftPosition(n,t)}},{key:"normalizeTopPosition",value:function(e,t){return e>t.realHeight-t.containerHeight&&(e=t.realHeight-t.containerHeight),e<0&&(e=0),e}},{key:"normalizeLeftPosition",value:function(e,t){return e>t.realWidth-t.containerWidth?e=t.realWidth-t.containerWidth:e<0&&(e=0),e}},{key:"computeSizes",value:function(){var e=this.content.offsetHeight,t=this.wrapper.offsetHeight,n=this.content.offsetWidth,o=this.wrapper.offsetWidth;return{realHeight:e,containerHeight:t,realWidth:n,containerWidth:o}}},{key:"setSizesToState",value:function(){var e=this.computeSizes();e.realHeight===this.state.realHeight&&e.realWidth===this.state.realWidth||this.setStateFromEvent(this.getModifiedPositionsIfNeeded(e))}},{key:"scrollTop",value:function(){this.scrollYTo(0)}},{key:"scrollBottom",value:function(){this.scrollYTo(this.state.realHeight-this.state.containerHeight)}},{key:"scrollLeft",value:function(){this.scrollXTo(0)}},{key:"scrollRight",value:function(){this.scrollXTo(this.state.realWidth-this.state.containerWidth)}},{key:"scrollYTo",value:function(e){if(this.canScrollY()){var t=this.normalizeTopPosition(e,this.computeSizes());this.setStateFromEvent({topPosition:t},S.api)}}},{key:"scrollXTo",value:function(e){if(this.canScrollX()){var t=this.normalizeLeftPosition(e,this.computeSizes());this.setStateFromEvent({leftPosition:t},S.api)}}},{key:"canScrollY",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state,t=e.realHeight>e.containerHeight;return t&&this.props.vertical}},{key:"canScrollX",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state,t=e.realWidth>e.containerWidth;return t&&this.props.horizontal}},{key:"getModifiedPositionsIfNeeded",value:function(e){var t=e.realHeight-e.containerHeight;this.state.topPosition>=t&&(e.topPosition=this.canScrollY(e)?(0,h.positiveOrZero)(t):0);var n=e.realWidth-e.containerWidth;return this.state.leftPosition>=n&&(e.leftPosition=this.canScrollX(e)?(0,h.positiveOrZero)(n):0),e}},{key:"focusContent",value:function(){this.content&&(0,h.findDOMNode)(this.content).focus()}}]),t}(f.default.Component);t.default=P,P.childContextTypes={scrollArea:f.default.PropTypes.object},P.propTypes={className:f.default.PropTypes.string,style:f.default.PropTypes.object,speed:f.default.PropTypes.number,contentClassName:f.default.PropTypes.string,contentStyle:f.default.PropTypes.object,vertical:f.default.PropTypes.bool,verticalContainerStyle:f.default.PropTypes.object,verticalScrollbarStyle:f.default.PropTypes.object,horizontal:f.default.PropTypes.bool,horizontalContainerStyle:f.default.PropTypes.object,horizontalScrollbarStyle:f.default.PropTypes.object,onScroll:f.default.PropTypes.func,contentWindow:f.default.PropTypes.any,ownerDocument:f.default.PropTypes.any,smoothScrolling:f.default.PropTypes.bool,minScrollSize:f.default.PropTypes.number,swapWheelAxes:f.default.PropTypes.bool,stopScrollPropagation:f.default.PropTypes.bool,focusableTabIndex:f.default.PropTypes.number},P.defaultProps={speed:1,vertical:!0,horizontal:!0,smoothScrolling:!1,swapWheelAxes:!1,contentWindow:"object"===("undefined"==typeof window?"undefined":l(window))?window:void 0,ownerDocument:"object"===("undefined"==typeof document?"undefined":l(document))?document:void 0,focusableTabIndex:1}},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u=n(1),c=o(u),f=n(10),p=n(8),d=function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),o=n.calculateState(e);return n.state={position:o.position,scrollSize:o.scrollSize,isDragging:!1,lastClientPosition:0},"vertical"===e.type?n.bindedHandleMouseMove=n.handleMouseMoveForVertical.bind(n):n.bindedHandleMouseMove=n.handleMouseMoveForHorizontal.bind(n),n.bindedHandleMouseUp=n.handleMouseUp.bind(n),n}return a(t,e),s(t,[{key:"componentDidMount",value:function(){this.props.ownerDocument&&(this.props.ownerDocument.addEventListener("mousemove",this.bindedHandleMouseMove),this.props.ownerDocument.addEventListener("mouseup",this.bindedHandleMouseUp))}},{key:"componentWillReceiveProps",value:function(e){this.setState(this.calculateState(e))}},{key:"componentWillUnmount",value:function(){this.props.ownerDocument&&(this.props.ownerDocument.removeEventListener("mousemove",this.bindedHandleMouseMove),this.props.ownerDocument.removeEventListener("mouseup",this.bindedHandleMouseUp))}},{key:"calculateFractionalPosition",value:function(e,t,n){var o=e-t;return 1-(o-n)/o}},{key:"calculateState",value:function(e){var t=this.calculateFractionalPosition(e.realSize,e.containerSize,e.position),n=e.containerSize*e.containerSize/e.realSize,o=n<e.minScrollSize?e.minScrollSize:n,r=(e.containerSize-o)*t;return{scrollSize:o,position:Math.round(r)}}},{key:"render",value:function(){var e=this,t=this.props,n=t.smoothScrolling,o=t.isDragging,r=t.type,i=t.scrollbarStyle,a=t.containerStyle,s="horizontal"===r,u="vertical"===r,d=this.createScrollStyles(),h=n?(0,p.modifyObjValues)(d,function(e){return(0,f.spring)(e)}):d,y="scrollbar-container "+(o?"active":"")+" "+(s?"horizontal":"")+" "+(u?"vertical":"");return c.default.createElement(f.Motion,{style:h},function(t){return c.default.createElement("div",{className:y,style:a,onMouseDown:e.handleScrollBarContainerClick.bind(e),ref:function(t){return e.scrollbarContainer=t}},c.default.createElement("div",{className:"scrollbar",style:l({},i,t),onMouseDown:e.handleMouseDown.bind(e)}))})}},{key:"handleScrollBarContainerClick",value:function(e){e.preventDefault();var t=this.computeMultiplier(),n=this.isVertical()?e.clientY:e.clientX,o=this.scrollbarContainer.getBoundingClientRect(),r=o.top,i=o.left,a=this.isVertical()?r:i,l=n-a,s=this.props.containerSize*this.props.containerSize/this.props.realSize;this.setState({isDragging:!0,lastClientPosition:n}),this.props.onPositionChange((l-s/2)/t)}},{key:"handleMouseMoveForHorizontal",value:function(e){var t=this.computeMultiplier();if(this.state.isDragging){e.preventDefault();var n=this.state.lastClientPosition-e.clientX;this.setState({lastClientPosition:e.clientX}),this.props.onMove(0,n/t)}}},{key:"handleMouseMoveForVertical",value:function(e){var t=this.computeMultiplier();if(this.state.isDragging){e.preventDefault();var n=this.state.lastClientPosition-e.clientY;this.setState({lastClientPosition:e.clientY}),this.props.onMove(n/t,0)}}},{key:"handleMouseDown",value:function(e){e.preventDefault(),e.stopPropagation();var t=this.isVertical()?e.clientY:e.clientX;this.setState({isDragging:!0,lastClientPosition:t}),this.props.onFocus()}},{key:"handleMouseUp",value:function(e){e.preventDefault(),this.setState({isDragging:!1})}},{key:"createScrollStyles",value:function(){return"vertical"===this.props.type?{height:this.state.scrollSize,marginTop:this.state.position}:{width:this.state.scrollSize,marginLeft:this.state.position}}},{key:"computeMultiplier",value:function(){return this.props.containerSize/this.props.realSize}},{key:"isVertical",value:function(){return"vertical"===this.props.type}}]),t}(c.default.Component);d.propTypes={onMove:c.default.PropTypes.func,onPositionChange:c.default.PropTypes.func,onFocus:c.default.PropTypes.func,realSize:c.default.PropTypes.number,containerSize:c.default.PropTypes.number,position:c.default.PropTypes.number,containerStyle:c.default.PropTypes.object,scrollbarStyle:c.default.PropTypes.object,type:c.default.PropTypes.oneOf(["vertical","horizontal"]),ownerDocument:c.default.PropTypes.any,smoothScrolling:c.default.PropTypes.bool,minScrollSize:c.default.PropTypes.number},d.defaultProps={type:"vertical",smoothScrolling:!1},t.default=d},function(e,t){var n=function(e,t,n){return n=window.getComputedStyle,(n?n(e):e.currentStyle)[t.replace(/-(\w)/gi,function(e,t){return t.toUpperCase()})]};e.exports=n},function(e,t,n){function o(e){var t=r(e,"line-height"),n=parseFloat(t,10);if(t===n+""){var o=e.style.lineHeight;e.style.lineHeight=t+"em",t=r(e,"line-height"),n=parseFloat(t,10),o?e.style.lineHeight=o:delete e.style.lineHeight}if(t.indexOf("pt")!==-1?(n*=4,n/=3):t.indexOf("mm")!==-1?(n*=96,n/=25.4):t.indexOf("cm")!==-1?(n*=96,n/=2.54):t.indexOf("in")!==-1?n*=96:t.indexOf("pc")!==-1&&(n*=16),n=Math.round(n),"normal"===t){var i=e.nodeName,a=document.createElement(i);a.innerHTML="&nbsp;";var l=r(e,"font-size");a.style.fontSize=l;var s=document.body;s.appendChild(a);var u=a.offsetHeight;n=u,s.removeChild(a)}return n}var r=n(13);e.exports=o},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(e){if(c===setTimeout)return setTimeout(e,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(e,0);try{return c(e,0)}catch(t){try{return c.call(null,e,0)}catch(t){return c.call(this,e,0)}}}function i(e){if(f===clearTimeout)return clearTimeout(e);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function a(){y&&d&&(y=!1,d.length?h=d.concat(h):m=-1,h.length&&l())}function l(){if(!y){var e=r(a);y=!0;for(var t=h.length;t;){for(d=h,h=[];++m<t;)d&&d[m].run();m=-1,t=h.length}d=null,y=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var c,f,p=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(e){c=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(e){f=o}}();var d,h=[],y=!1,m=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||y||r(l)},s.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=u,p.addListener=u,p.once=u,p.off=u,p.removeListener=u,p.removeAllListeners=u,p.emit=u,p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},i=n(4),a=o(i),l=n(7),s=o(l),u=n(6),c=o(u),f=n(2),p=o(f),d=n(3),h=o(d),y=n(5),m=o(y),v=n(1),S=o(v),P=1e3/60,g=S.default.createClass({displayName:"Motion",propTypes:{defaultStyle:v.PropTypes.objectOf(v.PropTypes.number),style:v.PropTypes.objectOf(v.PropTypes.oneOfType([v.PropTypes.number,v.PropTypes.object])).isRequired,children:v.PropTypes.func.isRequired,onRest:v.PropTypes.func},getInitialState:function(){var e=this.props,t=e.defaultStyle,n=e.style,o=t||s.default(n),r=a.default(o);return{currentStyle:o,currentVelocity:r,lastIdealStyle:o,lastIdealVelocity:r}},wasAnimating:!1,animationID:null,prevTime:0,accumulatedTime:0,unreadPropStyle:null,clearUnreadPropStyle:function(e){var t=!1,n=this.state,o=n.currentStyle,i=n.currentVelocity,a=n.lastIdealStyle,l=n.lastIdealVelocity;for(var s in e)if(Object.prototype.hasOwnProperty.call(e,s)){var u=e[s];"number"==typeof u&&(t||(t=!0,o=r({},o),i=r({},i),a=r({},a),l=r({},l)),o[s]=u,i[s]=0,a[s]=u,l[s]=0)}t&&this.setState({currentStyle:o,currentVelocity:i,lastIdealStyle:a,lastIdealVelocity:l})},startAnimationIfNecessary:function(){var e=this;this.animationID=h.default(function(t){var n=e.props.style;if(m.default(e.state.currentStyle,n,e.state.currentVelocity))return e.wasAnimating&&e.props.onRest&&e.props.onRest(),e.animationID=null,e.wasAnimating=!1,void(e.accumulatedTime=0);e.wasAnimating=!0;var o=t||p.default(),r=o-e.prevTime;if(e.prevTime=o,e.accumulatedTime=e.accumulatedTime+r,e.accumulatedTime>10*P&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();var i=(e.accumulatedTime-Math.floor(e.accumulatedTime/P)*P)/P,a=Math.floor(e.accumulatedTime/P),l={},s={},u={},f={};for(var d in n)if(Object.prototype.hasOwnProperty.call(n,d)){var h=n[d];if("number"==typeof h)u[d]=h,f[d]=0,l[d]=h,s[d]=0;else{for(var y=e.state.lastIdealStyle[d],v=e.state.lastIdealVelocity[d],S=0;S<a;S++){var g=c.default(P/1e3,y,v,h.val,h.stiffness,h.damping,h.precision);y=g[0],v=g[1]}var b=c.default(P/1e3,y,v,h.val,h.stiffness,h.damping,h.precision),T=b[0],w=b[1];u[d]=y+(T-y)*i,f[d]=v+(w-v)*i,l[d]=y,s[d]=v}}e.animationID=null,e.accumulatedTime-=a*P,e.setState({currentStyle:u,currentVelocity:f,lastIdealStyle:l,lastIdealVelocity:s}),e.unreadPropStyle=null,e.startAnimationIfNecessary()})},componentDidMount:function(){this.prevTime=p.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){null!=this.unreadPropStyle&&this.clearUnreadPropStyle(this.unreadPropStyle),this.unreadPropStyle=e.style,null==this.animationID&&(this.prevTime=p.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){null!=this.animationID&&(h.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=this.props.children(this.state.currentStyle);return e&&S.default.Children.only(e)}});t.default=g,e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t,n){for(var o=0;o<e.length;o++)if(!v.default(e[o],t[o],n[o]))return!1;return!0}t.__esModule=!0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},a=n(4),l=o(a),s=n(7),u=o(s),c=n(6),f=o(c),p=n(2),d=o(p),h=n(3),y=o(h),m=n(5),v=o(m),S=n(1),P=o(S),g=1e3/60,b=P.default.createClass({displayName:"StaggeredMotion",propTypes:{defaultStyles:S.PropTypes.arrayOf(S.PropTypes.objectOf(S.PropTypes.number)),styles:S.PropTypes.func.isRequired,children:S.PropTypes.func.isRequired},getInitialState:function(){var e=this.props,t=e.defaultStyles,n=e.styles,o=t||n().map(u.default),r=o.map(function(e){return l.default(e)});return{currentStyles:o,currentVelocities:r,lastIdealStyles:o,lastIdealVelocities:r}},animationID:null,prevTime:0,accumulatedTime:0,unreadPropStyles:null,clearUnreadPropStyle:function(e){for(var t=this.state,n=t.currentStyles,o=t.currentVelocities,r=t.lastIdealStyles,a=t.lastIdealVelocities,l=!1,s=0;s<e.length;s++){var u=e[s],c=!1;for(var f in u)if(Object.prototype.hasOwnProperty.call(u,f)){var p=u[f];"number"==typeof p&&(c||(c=!0,l=!0,n[s]=i({},n[s]),o[s]=i({},o[s]),r[s]=i({},r[s]),a[s]=i({},a[s])),n[s][f]=p,o[s][f]=0,r[s][f]=p,a[s][f]=0)}}l&&this.setState({currentStyles:n,currentVelocities:o,lastIdealStyles:r,lastIdealVelocities:a})},startAnimationIfNecessary:function(){var e=this;this.animationID=y.default(function(t){var n=e.props.styles(e.state.lastIdealStyles);if(r(e.state.currentStyles,n,e.state.currentVelocities))return e.animationID=null,void(e.accumulatedTime=0);var o=t||d.default(),i=o-e.prevTime;if(e.prevTime=o,e.accumulatedTime=e.accumulatedTime+i,e.accumulatedTime>10*g&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();for(var a=(e.accumulatedTime-Math.floor(e.accumulatedTime/g)*g)/g,l=Math.floor(e.accumulatedTime/g),s=[],u=[],c=[],p=[],h=0;h<n.length;h++){var y=n[h],m={},v={},S={},P={};for(var b in y)if(Object.prototype.hasOwnProperty.call(y,b)){var T=y[b];if("number"==typeof T)m[b]=T,v[b]=0,S[b]=T,P[b]=0;else{for(var w=e.state.lastIdealStyles[h][b],k=e.state.lastIdealVelocities[h][b],M=0;M<l;M++){var O=f.default(g/1e3,w,k,T.val,T.stiffness,T.damping,T.precision);w=O[0],k=O[1]}var I=f.default(g/1e3,w,k,T.val,T.stiffness,T.damping,T.precision),D=I[0],z=I[1];m[b]=w+(D-w)*a,v[b]=k+(z-k)*a,S[b]=w,P[b]=k}}c[h]=m,p[h]=v,s[h]=S,u[h]=P}e.animationID=null,e.accumulatedTime-=l*g,e.setState({currentStyles:c,currentVelocities:p,lastIdealStyles:s,lastIdealVelocities:u}),e.unreadPropStyles=null,e.startAnimationIfNecessary()})},componentDidMount:function(){this.prevTime=d.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){null!=this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles),this.unreadPropStyles=e.styles(this.state.lastIdealStyles),null==this.animationID&&(this.prevTime=d.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){null!=this.animationID&&(y.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=this.props.children(this.state.currentStyles);return e&&P.default.Children.only(e)}});t.default=b,e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t,n){var o=t;return null==o?e.map(function(e,t){return{key:e.key,data:e.data,style:n[t]}}):e.map(function(e,t){for(var r=0;r<o.length;r++)if(o[r].key===e.key)return{key:o[r].key,data:o[r].data,style:n[t]};return{key:e.key,data:e.data,style:n[t]}})}function i(e,t,n,o){if(o.length!==t.length)return!1;for(var r=0;r<o.length;r++)if(o[r].key!==t[r].key)return!1;for(var r=0;r<o.length;r++)if(!b.default(e[r],t[r].style,n[r]))return!1;return!0}function a(e,t,n,o,r,i,a,l){for(var s=y.default(n,o,function(e,n){var o=t(n);return null==o?null:b.default(r[e],o,i[e])?null:{key:n.key,data:n.data,style:o}}),c=[],f=[],p=[],d=[],h=0;h<s.length;h++){for(var m=s[h],v=null,S=0;S<n.length;S++)if(n[S].key===m.key){v=S;break}if(null==v){var P=e(m);c[h]=P,p[h]=P;var g=u.default(m.style);f[h]=g,d[h]=g}else c[h]=r[v],p[h]=a[v],f[h]=i[v],d[h]=l[v]}return[s,c,f,p,d]}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},s=n(4),u=o(s),c=n(7),f=o(c),p=n(6),d=o(p),h=n(19),y=o(h),m=n(2),v=o(m),S=n(3),P=o(S),g=n(5),b=o(g),T=n(1),w=o(T),k=1e3/60,M=w.default.createClass({displayName:"TransitionMotion",propTypes:{defaultStyles:T.PropTypes.arrayOf(T.PropTypes.shape({key:T.PropTypes.string.isRequired,data:T.PropTypes.any,style:T.PropTypes.objectOf(T.PropTypes.number).isRequired})),styles:T.PropTypes.oneOfType([T.PropTypes.func,T.PropTypes.arrayOf(T.PropTypes.shape({key:T.PropTypes.string.isRequired,data:T.PropTypes.any,style:T.PropTypes.objectOf(T.PropTypes.oneOfType([T.PropTypes.number,T.PropTypes.object])).isRequired}))]).isRequired,children:T.PropTypes.func.isRequired,willLeave:T.PropTypes.func,willEnter:T.PropTypes.func},getDefaultProps:function(){return{willEnter:function(e){return f.default(e.style)},willLeave:function(){return null}}},getInitialState:function(){var e=this.props,t=e.defaultStyles,n=e.styles,o=e.willEnter,r=e.willLeave,i="function"==typeof n?n(t):n,l=void 0;l=null==t?i:t.map(function(e){for(var t=0;t<i.length;t++)if(i[t].key===e.key)return i[t];return e});var s=null==t?i.map(function(e){return f.default(e.style)}):t.map(function(e){return f.default(e.style)}),c=null==t?i.map(function(e){return u.default(e.style)}):t.map(function(e){return u.default(e.style)}),p=a(o,r,l,i,s,c,s,c),d=p[0],h=p[1],y=p[2],m=p[3],v=p[4];return{currentStyles:h,currentVelocities:y,lastIdealStyles:m,lastIdealVelocities:v,mergedPropsStyles:d}},unmounting:!1,animationID:null,
	prevTime:0,accumulatedTime:0,unreadPropStyles:null,clearUnreadPropStyle:function(e){for(var t=a(this.props.willEnter,this.props.willLeave,this.state.mergedPropsStyles,e,this.state.currentStyles,this.state.currentVelocities,this.state.lastIdealStyles,this.state.lastIdealVelocities),n=t[0],o=t[1],r=t[2],i=t[3],s=t[4],u=0;u<e.length;u++){var c=e[u].style,f=!1;for(var p in c)if(Object.prototype.hasOwnProperty.call(c,p)){var d=c[p];"number"==typeof d&&(f||(f=!0,o[u]=l({},o[u]),r[u]=l({},r[u]),i[u]=l({},i[u]),s[u]=l({},s[u]),n[u]={key:n[u].key,data:n[u].data,style:l({},n[u].style)}),o[u][p]=d,r[u][p]=0,i[u][p]=d,s[u][p]=0,n[u].style[p]=d)}}this.setState({currentStyles:o,currentVelocities:r,mergedPropsStyles:n,lastIdealStyles:i,lastIdealVelocities:s})},startAnimationIfNecessary:function(){var e=this;this.unmounting||(this.animationID=P.default(function(t){var n=e.props.styles,o="function"==typeof n?n(r(e.state.mergedPropsStyles,e.unreadPropStyles,e.state.lastIdealStyles)):n;if(i(e.state.currentStyles,o,e.state.currentVelocities,e.state.mergedPropsStyles))return e.animationID=null,void(e.accumulatedTime=0);var l=t||v.default(),s=l-e.prevTime;if(e.prevTime=l,e.accumulatedTime=e.accumulatedTime+s,e.accumulatedTime>10*k&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();for(var u=(e.accumulatedTime-Math.floor(e.accumulatedTime/k)*k)/k,c=Math.floor(e.accumulatedTime/k),f=a(e.props.willEnter,e.props.willLeave,e.state.mergedPropsStyles,o,e.state.currentStyles,e.state.currentVelocities,e.state.lastIdealStyles,e.state.lastIdealVelocities),p=f[0],h=f[1],y=f[2],m=f[3],S=f[4],P=0;P<p.length;P++){var g=p[P].style,b={},T={},w={},M={};for(var O in g)if(Object.prototype.hasOwnProperty.call(g,O)){var I=g[O];if("number"==typeof I)b[O]=I,T[O]=0,w[O]=I,M[O]=0;else{for(var D=m[P][O],z=S[P][O],_=0;_<c;_++){var j=d.default(k/1e3,D,z,I.val,I.stiffness,I.damping,I.precision);D=j[0],z=j[1]}var C=d.default(k/1e3,D,z,I.val,I.stiffness,I.damping,I.precision),x=C[0],V=C[1];b[O]=D+(x-D)*u,T[O]=z+(V-z)*u,w[O]=D,M[O]=z}}m[P]=w,S[P]=M,h[P]=b,y[P]=T}e.animationID=null,e.accumulatedTime-=c*k,e.setState({currentStyles:h,currentVelocities:y,lastIdealStyles:m,lastIdealVelocities:S,mergedPropsStyles:p}),e.unreadPropStyles=null,e.startAnimationIfNecessary()}))},componentDidMount:function(){this.prevTime=v.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles);var t=e.styles;"function"==typeof t?this.unreadPropStyles=t(r(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles)):this.unreadPropStyles=t,null==this.animationID&&(this.prevTime=v.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){this.unmounting=!0,null!=this.animationID&&(P.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=r(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles),t=this.props.children(e);return t&&w.default.Children.only(t)}});t.default=M,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var o={},r=0;r<e.length;r++)o[e[r].key]=r;for(var i={},r=0;r<t.length;r++)i[t[r].key]=r;for(var a=[],r=0;r<t.length;r++)a[r]=t[r];for(var r=0;r<e.length;r++)if(!Object.prototype.hasOwnProperty.call(i,e[r].key)){var l=n(r,e[r]);null!=l&&a.push(l)}return a.sort(function(e,n){var r=i[e.key],a=i[n.key],l=o[e.key],s=o[n.key];if(null!=r&&null!=a)return i[e.key]-i[n.key];if(null!=l&&null!=s)return o[e.key]-o[n.key];if(null!=r){for(var u=0;u<t.length;u++){var c=t[u].key;if(Object.prototype.hasOwnProperty.call(o,c)){if(r<i[c]&&s>o[c])return-1;if(r>i[c]&&s<o[c])return 1}}return 1}for(var u=0;u<t.length;u++){var c=t[u].key;if(Object.prototype.hasOwnProperty.call(o,c)){if(a<i[c]&&l>o[c])return 1;if(a>i[c]&&l<o[c])return-1}}return-1})}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function o(){}t.__esModule=!0,t.default=o;e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){return i({},s,t,{val:e})}t.__esModule=!0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};t.default=r;var a=n(9),l=o(a),s=i({},l.default.noWobble,{precision:.01});e.exports=t.default}])});

/***/ }),

/***/ "./node_modules/react-toastify/lib/DefaultCloseButton.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/require-default-props: 0 */
	function DefaultCloseButton(_ref) {
	  var closeToast = _ref.closeToast;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      className: 'toastify__close',
	      type: 'button',
	      onClick: closeToast
	    },
	    '\u2716'
	  );
	}
	
	DefaultCloseButton.propTypes = {
	  closeToast: _propTypes2.default.func
	};
	
	exports.default = DefaultCloseButton;

/***/ }),

/***/ "./node_modules/react-toastify/lib/ProgressBar.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__("./node_modules/react-toastify/lib/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgressBar(_ref) {
	  var delay = _ref.delay,
	      isRunning = _ref.isRunning,
	      closeToast = _ref.closeToast,
	      type = _ref.type,
	      hide = _ref.hide,
	      className = _ref.className;
	
	  var style = {
	    animationDuration: delay + 'ms',
	    animationPlayState: isRunning ? 'running' : 'paused'
	  };
	  style.WebkitAnimationPlayState = style.animationPlayState;
	
	  if (hide) {
	    style.opacity = 0;
	  }
	
	  return _react2.default.createElement('div', {
	    className: 'toastify__progress toastify__progress--' + type + ' ' + className,
	    style: style,
	    onAnimationEnd: closeToast
	  });
	}
	
	ProgressBar.propTypes = {
	  /**
	   * The animation delay which determine when to close the toast
	   */
	  delay: _propTypes2.default.number.isRequired,
	
	  /**
	   * Whether or not the animation is running or paused
	   */
	  isRunning: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Func to close the current toast
	   */
	  closeToast: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optional type : info, success ...
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Hide or not the progress bar
	   */
	  hide: _propTypes2.default.bool,
	
	  /**
	   * Optionnal className
	   */
	  className: _propTypes2.default.string
	};
	
	ProgressBar.defaultProps = {
	  type: _config2.default.TYPE.DEFAULT,
	  hide: false,
	  className: ''
	};
	
	exports.default = ProgressBar;

/***/ }),

/***/ "./node_modules/react-toastify/lib/Toast.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgressBar = __webpack_require__("./node_modules/react-toastify/lib/ProgressBar.js");
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _config = __webpack_require__("./node_modules/react-toastify/lib/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _objectValues = __webpack_require__("./node_modules/react-toastify/lib/util/objectValues.js");
	
	var _objectValues2 = _interopRequireDefault(_objectValues);
	
	var _propValidator = __webpack_require__("./node_modules/react-toastify/lib/util/propValidator.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = function (_Component) {
	  _inherits(Toast, _Component);
	
	  function Toast(props) {
	    _classCallCheck(this, Toast);
	
	    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));
	
	    _this.setRef = function (ref) {
	      _this.ref = ref;
	    };
	
	    _this.pauseToast = function () {
	      _this.setState({ isRunning: false });
	    };
	
	    _this.playToast = function () {
	      _this.setState({ isRunning: true });
	    };
	
	    _this.ref = null;
	    _this.state = {
	      isRunning: true
	    };
	    return _this;
	  }
	
	  _createClass(Toast, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onOpen !== null && this.props.onOpen(this.getChildrenProps());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClose !== null && this.props.onClose(this.getChildrenProps());
	    }
	  }, {
	    key: 'getChildrenProps',
	    value: function getChildrenProps() {
	      return this.props.children.props;
	    }
	  }, {
	    key: 'getToastProps',
	    value: function getToastProps() {
	      var toastProps = {
	        className: 'toastify-content toastify-content--' + this.props.type + ' ' + this.props.className,
	        ref: this.setRef
	      };
	
	      if (this.props.autoClose !== false && this.props.pauseOnHover === true) {
	        toastProps.onMouseEnter = this.pauseToast;
	        toastProps.onMouseLeave = this.playToast;
	      }
	
	      this.props.closeOnClick && (toastProps.onClick = this.props.closeToast);
	
	      return toastProps;
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.ref.classList.add('toast-enter--' + this.props.position, 'toastify-animated');
	      callback();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.ref.classList.add('toast-enter--' + this.props.position, 'toastify-animated');
	      callback();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.ref.classList.remove('toast-enter--' + this.props.position, 'toastify-animated');
	      this.ref.classList.add('toast-exit--' + this.props.position, 'toastify-animated');
	      setTimeout(function () {
	        return callback();
	      }, 750);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          closeButton = _props.closeButton,
	          children = _props.children,
	          autoClose = _props.autoClose,
	          type = _props.type,
	          hideProgressBar = _props.hideProgressBar,
	          closeToast = _props.closeToast;
	
	
	      return _react2.default.createElement(
	        'div',
	        this.getToastProps(),
	        _react2.default.createElement(
	          'div',
	          { className: 'toastify__body ' + this.props.bodyClassName },
	          children
	        ),
	        closeButton !== false && closeButton,
	        autoClose !== false && _react2.default.createElement(_ProgressBar2.default, {
	          delay: autoClose,
	          isRunning: this.state.isRunning,
	          closeToast: closeToast,
	          hide: hideProgressBar,
	          type: type,
	          className: this.props.progressClassName
	        })
	      );
	    }
	  }]);
	
	  return Toast;
	}(_react.Component);
	
	Toast.propTypes = {
	  closeButton: _propValidator.falseOrElement.isRequired,
	  autoClose: _propValidator.falseOrNumber.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  closeToast: _propTypes2.default.func.isRequired,
	  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.POSITION)).isRequired,
	  pauseOnHover: _propTypes2.default.bool.isRequired,
	  closeOnClick: _propTypes2.default.bool.isRequired,
	  hideProgressBar: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.TYPE)),
	  className: _propTypes2.default.string,
	  bodyClassName: _propTypes2.default.string,
	  progressClassName: _propTypes2.default.string
	};
	Toast.defaultProps = {
	  type: _config2.default.TYPE.DEFAULT,
	  hideProgressBar: false,
	  onOpen: null,
	  onClose: null,
	  className: '',
	  bodyClassName: '',
	  progressClassName: ''
	};
	exports.default = Toast;

/***/ }),

/***/ "./node_modules/react-toastify/lib/ToastContainer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Toast = __webpack_require__("./node_modules/react-toastify/lib/Toast.js");
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _DefaultCloseButton = __webpack_require__("./node_modules/react-toastify/lib/DefaultCloseButton.js");
	
	var _DefaultCloseButton2 = _interopRequireDefault(_DefaultCloseButton);
	
	var _config = __webpack_require__("./node_modules/react-toastify/lib/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _EventManager = __webpack_require__("./node_modules/react-toastify/lib/util/EventManager.js");
	
	var _EventManager2 = _interopRequireDefault(_EventManager);
	
	var _objectValues = __webpack_require__("./node_modules/react-toastify/lib/util/objectValues.js");
	
	var _objectValues2 = _interopRequireDefault(_objectValues);
	
	var _propValidator = __webpack_require__("./node_modules/react-toastify/lib/util/propValidator.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToastContainer = function (_Component) {
	  _inherits(ToastContainer, _Component);
	
	  function ToastContainer(props) {
	    _classCallCheck(this, ToastContainer);
	
	    var _this = _possibleConstructorReturn(this, (ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).call(this, props));
	
	    _this.isToastActive = function (id) {
	      return _this.state.toast.indexOf(parseInt(id, 10)) !== -1;
	    };
	
	    _this.state = {
	      toast: []
	    };
	    _this.collection = {};
	    return _this;
	  }
	
	  _createClass(ToastContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _config$ACTION = _config2.default.ACTION,
	          SHOW = _config$ACTION.SHOW,
	          CLEAR = _config$ACTION.CLEAR,
	          MOUNTED = _config$ACTION.MOUNTED;
	
	      _EventManager2.default.on(SHOW, function (content, options) {
	        return _this2.show(content, options);
	      }).on(CLEAR, function (id) {
	        return id !== null ? _this2.removeToast(id) : _this2.clear();
	      }).emit(MOUNTED, this);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _EventManager2.default.off(_config2.default.ACTION.SHOW);
	      _EventManager2.default.off(_config2.default.ACTION.CLEAR);
	    }
	  }, {
	    key: "removeToast",
	    value: function removeToast(id) {
	      this.setState({
	        toast: this.state.toast.filter(function (v) {
	          return v !== parseInt(id, 10);
	        })
	      });
	    }
	  }, {
	    key: "with",
	    value: function _with(component, props) {
	      return (0, _react.cloneElement)(component, _extends({}, props, component.props));
	    }
	  }, {
	    key: "makeCloseButton",
	    value: function makeCloseButton(toastClose, toastId) {
	      var _this3 = this;
	
	      var closeButton = this.props.closeButton;
	
	      if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
	        closeButton = toastClose;
	      }
	
	      return closeButton === false ? false : this.with(closeButton, {
	        closeToast: function closeToast() {
	          return _this3.removeToast(toastId);
	        }
	      });
	    }
	  }, {
	    key: "getAutoCloseDelay",
	    value: function getAutoCloseDelay(toastAutoClose) {
	      return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
	    }
	  }, {
	    key: "isFunction",
	    value: function isFunction(object) {
	      return !!(object && object.constructor && object.call && object.apply);
	    }
	  }, {
	    key: "canBeRendered",
	    value: function canBeRendered(content) {
	      return (0, _react.isValidElement)(content) || (0, _propValidator.typeOf)(content) === "String" || (0, _propValidator.typeOf)(content) === "Number";
	    }
	  }, {
	    key: "show",
	    value: function show(content, options) {
	      var _this4 = this;
	
	      if (!this.canBeRendered(content)) {
	        throw new Error("The element you provided cannot be rendered. You provided an element of type " + (typeof content === "undefined" ? "undefined" : _typeof(content)));
	      }
	      var toastId = options.toastId;
	      var closeToast = function closeToast() {
	        return _this4.removeToast(toastId);
	      };
	      var toastOptions = {
	        id: toastId,
	        type: options.type,
	        closeButton: this.makeCloseButton(options.closeButton, toastId),
	        position: options.position || this.props.position,
	        pauseOnHover: options.pauseOnHover !== null ? options.pauseOnHover : this.props.pauseOnHover,
	        closeOnClick: options.closeOnClick !== null ? options.closeOnClick : this.props.closeOnClick,
	        className: options.className || this.props.toastClassName,
	        bodyClassName: options.bodyClassName || this.props.bodyClassName,
	        progressClassName: options.progressClassName || this.props.progressClassName
	      };
	
	      this.isFunction(options.onOpen) && (toastOptions.onOpen = options.onOpen);
	
	      this.isFunction(options.onClose) && (toastOptions.onClose = options.onClose);
	
	      toastOptions.autoClose = this.getAutoCloseDelay(options.autoClose !== false ? parseInt(options.autoClose, 10) : options.autoClose);
	
	      toastOptions.hideProgressBar = typeof options.hideProgressBar === "boolean" ? options.hideProgressBar : this.props.hideProgressBar;
	
	      toastOptions.closeToast = closeToast;
	
	      if ((0, _react.isValidElement)(content) && (0, _propValidator.typeOf)(content.type) !== "String") {
	        content = this.with(content, {
	          closeToast: closeToast
	        });
	      }
	
	      this.collection = _extends({}, this.collection, _defineProperty({}, toastId, {
	        content: this.makeToast(content, toastOptions),
	        position: toastOptions.position
	      }));
	
	      this.setState({
	        toast: [].concat(_toConsumableArray(this.state.toast), [toastId])
	      });
	    }
	  }, {
	    key: "makeToast",
	    value: function makeToast(content, options) {
	      return _react2.default.createElement(
	        _Toast2.default,
	        _extends({}, options, { key: "toast-" + options.id + " " }),
	        content
	      );
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.setState({ toast: [] });
	    }
	  }, {
	    key: "hasToast",
	    value: function hasToast() {
	      return this.state.toast.length > 0;
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(pos, disablePointer) {
	      var props = {
	        className: "toastify toastify--" + pos,
	        style: disablePointer ? { pointerEvents: "none" } : {}
	      };
	
	      if (this.props.className !== null) {
	        props.className = props.className + " " + this.props.className;
	      }
	
	      if (this.props.style !== null) {
	        props.style = _extends({}, this.props.style, props.style);
	      }
	
	      return props;
	    }
	  }, {
	    key: "renderToast",
	    value: function renderToast() {
	      var _this5 = this;
	
	      var toastToRender = {};
	      var collection = this.props.newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection);
	
	      collection.forEach(function (toastId) {
	        var item = _this5.collection[toastId];
	        toastToRender[item.position] || (toastToRender[item.position] = []);
	
	        if (_this5.state.toast.indexOf(parseInt(toastId, 10)) !== -1) {
	          toastToRender[item.position].push(item.content);
	        } else {
	          // Temporal zone for animation
	          toastToRender[item.position].push(null);
	          // Delay garbage collecting. Useful when a lots of toast
	          setTimeout(function () {
	            return delete _this5.collection[toastId];
	          }, collection.length * 10);
	        }
	      });
	
	      return Object.keys(toastToRender).map(function (position) {
	        var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
	
	        return _react2.default.createElement(
	          _TransitionGroup2.default,
	          _extends({
	            component: "div"
	          }, _this5.getContainerProps(position, disablePointer), {
	            key: "container-" + position
	          }),
	          toastToRender[position].map(function (item) {
	            return item;
	          })
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.renderToast()
	      );
	    }
	  }]);
	
	  return ToastContainer;
	}(_react.Component);
	
	ToastContainer.propTypes = {
	  /**
	   * Set toast position
	   */
	  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.POSITION)),
	
	  /**
	   * Disable or set autoClose delay
	   */
	  autoClose: _propValidator.falseOrNumber,
	
	  /**
	   * Disable or set a custom react element for the close button
	   */
	  closeButton: _propValidator.falseOrElement,
	
	  /**
	   * Hide or not progress bar when autoClose is enabled
	   */
	  hideProgressBar: _propTypes2.default.bool,
	
	  /**
	   * Pause toast duration on hover
	   */
	  pauseOnHover: _propTypes2.default.bool,
	
	  /**
	   * Dismiss toast on click
	   */
	  closeOnClick: _propTypes2.default.bool,
	
	  /**
	   * Newest on top
	   */
	  newestOnTop: _propTypes2.default.bool,
	
	  /**
	   * An optional className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className for the toast
	   */
	  toastClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className for the toast body
	   */
	  bodyClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className for the toast progress bar
	   */
	  progressClassName: _propTypes2.default.string
	};
	ToastContainer.defaultProps = {
	  position: _config2.default.POSITION.TOP_RIGHT,
	  autoClose: 5000,
	  hideProgressBar: false,
	  closeButton: _react2.default.createElement(_DefaultCloseButton2.default, null),
	  pauseOnHover: true,
	  closeOnClick: true,
	  newestOnTop: false,
	  className: null,
	  style: null,
	  toastClassName: '',
	  bodyClassName: '',
	  progressClassName: ''
	};
	exports.default = ToastContainer;

/***/ }),

/***/ "./node_modules/react-toastify/lib/config.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  POSITION: {
	    TOP_LEFT: 'top-left',
	    TOP_RIGHT: 'top-right',
	    TOP_CENTER: 'top-center',
	    BOTTOM_LEFT: 'bottom-left',
	    BOTTOM_RIGHT: 'bottom-right',
	    BOTTOM_CENTER: 'bottom-center'
	  },
	  TYPE: {
	    INFO: 'info',
	    SUCCESS: 'success',
	    WARNING: 'warning',
	    ERROR: 'error',
	    DEFAULT: 'default'
	  },
	  ACTION: {
	    SHOW: 'SHOW_TOAST',
	    CLEAR: 'CLEAR_TOAST',
	    MOUNTED: 'CONTAINER_MOUNTED'
	  }
	};

/***/ }),

/***/ "./node_modules/react-toastify/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toast = exports.ToastContainer = undefined;
	
	var _ToastContainer = __webpack_require__("./node_modules/react-toastify/lib/ToastContainer.js");
	
	var _ToastContainer2 = _interopRequireDefault(_ToastContainer);
	
	var _toaster = __webpack_require__("./node_modules/react-toastify/lib/toaster.js");
	
	var _toaster2 = _interopRequireDefault(_toaster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ToastContainer = _ToastContainer2.default;
	exports.toast = _toaster2.default;

/***/ }),

/***/ "./node_modules/react-toastify/lib/toaster.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                  * TODO: Add validation here :
	                                                                                                                                                                                                                                                                  *   - Validate type
	                                                                                                                                                                                                                                                                  *   - Maybe autoClose
	                                                                                                                                                                                                                                                                  *   - Maybe closeButton as well
	                                                                                                                                                                                                                                                                  * */
	
	
	var _EventManager = __webpack_require__("./node_modules/react-toastify/lib/util/EventManager.js");
	
	var _EventManager2 = _interopRequireDefault(_EventManager);
	
	var _config = __webpack_require__("./node_modules/react-toastify/lib/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSITION = _config2.default.POSITION,
	    TYPE = _config2.default.TYPE,
	    ACTION = _config2.default.ACTION;
	
	
	var defaultOptions = {
	  type: TYPE.DEFAULT,
	  autoClose: null,
	  closeButton: null,
	  hideProgressBar: null,
	  position: null,
	  pauseOnHover: null,
	  closeOnClick: null,
	  className: null,
	  bodyClassName: null,
	  progressClassName: null
	};
	
	var container = null;
	var queue = [];
	var toastId = 0;
	
	/**
	 * Merge provided options with the defaults settings and generate the toastId
	 * @param {*} options
	 */
	function mergeOptions(options) {
	  return _extends({}, defaultOptions, options, { toastId: ++toastId });
	}
	
	/**
	 * Dispatch toast. If the container is not mounted, the toast is enqueued
	 * @param {*} content
	 * @param {*} options
	 */
	function emitEvent(content, options) {
	  if (container !== null) {
	    _EventManager2.default.emit(ACTION.SHOW, content, options);
	  } else {
	    queue.push({ action: ACTION.SHOW, content: content, options: options });
	  }
	
	  return options.toastId;
	}
	
	var toaster = _extends(function (content, options) {
	  return emitEvent(content, mergeOptions(options));
	}, {
	  success: function success(content, options) {
	    return emitEvent(content, _extends(mergeOptions(options), { type: TYPE.SUCCESS }));
	  },
	  info: function info(content, options) {
	    return emitEvent(content, _extends(mergeOptions(options), { type: TYPE.INFO }));
	  },
	  warn: function warn(content, options) {
	    return emitEvent(content, _extends(mergeOptions(options), { type: TYPE.WARNING }));
	  },
	  warning: function warning(content, options) {
	    return emitEvent(content, _extends(mergeOptions(options), { type: TYPE.WARNING }));
	  },
	  error: function error(content, options) {
	    return emitEvent(content, _extends(mergeOptions(options), { type: TYPE.ERROR }));
	  },
	  dismiss: function dismiss() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    return _EventManager2.default.emit(ACTION.CLEAR, id);
	  },
	  isActive: function isActive() {
	    return false;
	  }
	}, {
	  POSITION: POSITION,
	  TYPE: TYPE
	});
	
	/**
	 * Wait until the ToastContainer is mounted to dispatch the toast
	 * and attach isActive method
	 */
	_EventManager2.default.on(ACTION.MOUNTED, function (containerInstance) {
	  container = containerInstance;
	
	  toaster.isActive = function (id) {
	    return container.isToastActive(id);
	  };
	
	  queue.forEach(function (item) {
	    _EventManager2.default.emit(item.action, item.content, item.options);
	  });
	  queue = [];
	});
	
	exports.default = toaster;

/***/ }),

/***/ "./node_modules/react-toastify/lib/util/EventManager.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var eventManager = {
	  eventList: new Map(),
	
	  on: function on(event, callback) {
	    this.eventList.has(event) || this.eventList.set(event, []);
	
	    this.eventList.get(event).push(callback);
	
	    return this;
	  },
	  off: function off() {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return this.eventList.delete(event);
	  },
	  emit: function emit(event) {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (!this.eventList.has(event)) {
	      /* eslint no-console: 0 */
	      console.warn("<" + event + "> Event is not registered. Did you forgot to bind the event ?");
	      return false;
	    }
	
	    this.eventList.get(event).forEach(function (callback) {
	      return setTimeout(function () {
	        return callback.call.apply(callback, [_this].concat(_toConsumableArray(args)));
	      }, 0);
	    });
	
	    return true;
	  }
	};
	
	exports.default = eventManager;

/***/ }),

/***/ "./node_modules/react-toastify/lib/util/objectValues.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  var values = [];
	  Object.keys(obj).forEach(function (key) {
	    return values.push(obj[key]);
	  });
	  return values;
	};

/***/ }),

/***/ "./node_modules/react-toastify/lib/util/propValidator.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.falseOrElement = exports.falseOrNumber = undefined;
	exports.typeOf = typeOf;
	exports.isValidDelay = isValidDelay;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	function typeOf(obj) {
	  return Object.prototype.toString.call(obj).slice(8, -1);
	}
	
	function isValidDelay(val) {
	  return typeOf(val) === 'Number' && !isNaN(val) && val > 0;
	}
	
	function withRequired(fn) {
	  fn.isRequired = function (props, propName, componentName) {
	    var prop = props[propName];
	
	    if (typeof prop === 'undefined') {
	      return new Error('The prop ' + propName + ' is marked as required in \n      ' + componentName + ', but its value is undefined.');
	    }
	
	    fn(props, propName, componentName);
	  };
	  return fn;
	}
	
	/**
	 * TODO: Maybe rethink about the name
	 */
	var falseOrNumber = exports.falseOrNumber = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !isValidDelay(prop)) {
	    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid Number > 0 or equal to false. ' + prop + ' given.');
	  }
	
	  return null;
	});
	
	var falseOrElement = exports.falseOrElement = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !(0, _react.isValidElement)(prop)) {
	    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid react element or equal to false. ' + prop + ' given.');
	  }
	
	  return null;
	});

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ "./src/components/ProductsFilters/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	__webpack_require__("./src/components/ProductsFilters/styles.sass");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------	Plugins
	
	
	//---------	Styles
	
	
	var ProductsFilters = function (_React$Component) {
	  _inherits(ProductsFilters, _React$Component);
	
	  //---------	Constructor
	  function ProductsFilters(props) {
	    _classCallCheck(this, ProductsFilters);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.categories = props.categories;
	    _this.browseAll = true;
	    _this.state = {
	      filters: []
	    };
	
	    _this.filter = _this.filter.bind(_this);
	    _this.setActiveClass = _this.setActiveClass.bind(_this);
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  ProductsFilters.prototype.componentDidMount = function componentDidMount() {
	    this.props.onRef(this);
	  };
	
	  ProductsFilters.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.onRef(undefined);
	  };
	
	  //---------	Custom functions
	
	
	  ProductsFilters.prototype.filter = function filter(product) {
	    var _this2 = this;
	
	    var filters = this.state.filters;
	
	    if (product === 'all' || filters.length === this.categories.length) {
	      filters = [];
	      this.browseAll = true;
	    } else {
	      this.browseAll = false;
	      (0, _lodash.includes)(filters, product) ? (0, _lodash.remove)(filters, function (filter) {
	        return filter === product;
	      }) : filters.push(product);
	    }
	    this.setState({ filters: filters }, function () {
	
	      if (_this2.state.filters.length === _this2.categories.length || _this2.state.filters.length === 0) {
	        _this2.state.filters = [];
	        _this2.browseAll = true;
	      }
	      _this2.props.filters(_this2.state.filters);
	    });
	  };
	
	  ProductsFilters.prototype.setActiveClass = function setActiveClass(category) {
	    return !(0, _lodash.includes)(this.state.filters, category) ? 'CalipsyProductsFilters-filter state-active' : 'CalipsyProductsFilters-filter';
	  };
	
	  ProductsFilters.prototype.renderFiltersList = function renderFiltersList() {
	    var _this3 = this;
	
	    var filtersList = [];
	
	    filtersList.push(_react2.default.createElement(
	      'span',
	      { key: 'all',
	        className: this.browseAll ? 'CalipsyProductsFilters-filter state-active' : 'CalipsyProductsFilters-filter',
	        onClick: function onClick() {
	          return _this3.filter('all');
	        } },
	      _react2.default.createElement(
	        'i',
	        null,
	        'show all'
	      )
	    ));
	
	    (0, _lodash.forEach)(this.categories, function (category) {
	      filtersList.push(_react2.default.createElement(
	        'span',
	        { key: category, className: _this3.setActiveClass(category),
	          onClick: function onClick() {
	            return _this3.filter(category);
	          } },
	        _react2.default.createElement(
	          'i',
	          null,
	          category
	        )
	      ));
	    });
	
	    return filtersList;
	  };
	
	  //---------	Render
	
	
	  ProductsFilters.prototype.render = function render() {
	    var _this4 = this;
	
	    var browseAllClass = this.browseAll ? 'CalipsyProductsFilters-filters state-browseAll' : 'CalipsyProductsFilters-filters';
	    return _react2.default.createElement(
	      'div',
	      { className: browseAllClass },
	      this.renderFiltersList(),
	      _react2.default.createElement(
	        'button',
	        { className: 'CalipsyButton CalipsyButton-blue', onClick: function onClick() {
	            return _this4.props.toggleSidebar('sendToast');
	          } },
	        'Update results'
	      )
	    );
	  };
	
	  return ProductsFilters;
	}(_react2.default.Component);
	
	exports.default = ProductsFilters;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/ProductsFilters/styles.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/ProductsList/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bricks = __webpack_require__("./node_modules/bricks.js/dist/bricks.js");
	
	var _bricks2 = _interopRequireDefault(_bricks);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _reactToastify = __webpack_require__("./node_modules/react-toastify/lib/index.js");
	
	__webpack_require__("./src/components/ProductsList/styles.sass");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------	Plugins
	
	
	//---------	Styles
	
	
	//---------	Translations
	
	
	var ProductsList = function (_React$Component) {
	  _inherits(ProductsList, _React$Component);
	
	  //---------	Constructor
	  function ProductsList(props) {
	    _classCallCheck(this, ProductsList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.productsList = props.productsList;
	    _this.pageReady = false;
	    _this.productsListGrid;
	    _this.state = {
	      filteredProducts: [],
	      stateTransition: false,
	      stateZoomOut: false
	    };
	
	    _this.gridLayout = _this.gridLayout.bind(_this);
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  ProductsList.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.gridLayout();
	    setTimeout(function () {
	      return _this2.pageReady = true;
	    }, 500);
	  };
	
	  ProductsList.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
	    this.filterProducts(newProps.filters);
	  };
	
	  //---------	Custom functions
	
	
	  ProductsList.prototype.gridLayout = function gridLayout() {
	    this.productsListGrid = (0, _bricks2.default)({
	      container: '.CalipsyProductsList-products',
	      packed: 'data-packed',
	      sizes: [{ columns: 1, gutter: 0 }, { mq: '600px', columns: 2, gutter: 20 }, { mq: '768px', columns: 2, gutter: 20 }, { mq: '992px', columns: 3, gutter: 20 }, { mq: '1120px', columns: 3, gutter: 30 }]
	    });
	    this.productsListGrid.pack().resize();
	  };
	
	  ProductsList.prototype.filterProducts = function filterProducts(filters) {
	    var products = [];
	    var filteredProducts = (0, _lodash.filter)(this.productsList, function (product) {
	      return !(0, _lodash.includes)(filters, product.category);
	    });
	
	    (0, _lodash.forOwn)(filteredProducts, function (product, key) {
	      return products.push(_react2.default.createElement(
	        'div',
	        { key: key, className: 'CalipsyProductsList-product' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: product.path },
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyProductsList-image' },
	            _react2.default.createElement('img', { src: product.thumbnail, alt: product.name }),
	            _react2.default.createElement(
	              'button',
	              { className: 'CalipsyButton' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _translations.T.shop.messages.viewDetails
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyProductsList-details' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              product.name,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                'from ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  '\xA3',
	                  product.price,
	                  _react2.default.createElement(
	                    'sup',
	                    null,
	                    '00'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ));
	    });
	
	    this.setState({ filteredProducts: products }, this.productsListGrid.pack);
	
	    if (this.pageReady && window.innerWidth >= 768) {
	      _reactToastify.toast.info(_react2.default.createElement(
	        'div',
	        { className: 'filtersApplied info' },
	        _translations.T.global.filtersApplied
	      ), {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 1500
	      });
	    }
	  };
	
	  //---------	Render
	
	
	  ProductsList.prototype.render = function render() {
	
	    var productsTransitionClass = 'CalipsyProductsList-products';
	
	    if (this.state.stateTransition) productsTransitionClass += ' state-transition';
	    if (this.state.stateZoomOut) productsTransitionClass += ' state-zoomOut';
	
	    return _react2.default.createElement(
	      'div',
	      { className: productsTransitionClass },
	      this.state.filteredProducts
	    );
	  };
	
	  return ProductsList;
	}(_react2.default.Component);
	
	exports.default = ProductsList;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/ProductsList/styles.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Sidebar/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noCss = __webpack_require__("./node_modules/react-scrollbar/dist/no-css.js");
	
	var _noCss2 = _interopRequireDefault(_noCss);
	
	var _translations = __webpack_require__("./translations/index.js");
	
	__webpack_require__("./src/components/Sidebar/scrollbar.sass");
	
	__webpack_require__("./src/components/Sidebar/index.sass");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------	Plugins
	
	
	//---------	Translations
	
	
	//---------	Styles
	
	
	var Sidebar = function (_React$Component) {
	  _inherits(Sidebar, _React$Component);
	
	  //---------	Constructor
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.title = props.title;
	    _this.state = {
	      sidebarActive: false
	    };
	    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  Sidebar.prototype.componentDidMount = function componentDidMount() {
	    this.props.onRef(this);
	  };
	
	  Sidebar.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.onRef(undefined);
	  };
	
	  //---------	Custom functions
	
	
	  Sidebar.prototype.toggleSidebar = function toggleSidebar() {
	    this.setState({ sidebarActive: !this.state.sidebarActive });
	  };
	
	  //---------	Render
	
	
	  Sidebar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.sidebarActive ? 'CalipsySidebar state-active' : 'CalipsySidebar' },
	      _react2.default.createElement('div', { className: 'CalipsySidebar-background', onClick: this.toggleSidebar }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsySidebar-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsySidebar-header' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'CalipsySidebar-title' },
	            this.title
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'CalipsySidebar-close', onClick: this.toggleSidebar },
	            _translations.T.global.close
	          )
	        ),
	        _react2.default.createElement(
	          _noCss2.default,
	          {
	            speed: 0.8,
	            className: 'area',
	            contentClassName: 'content',
	            horizontal: false },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return Sidebar;
	}(_react2.default.Component);
	
	exports.default = Sidebar;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Sidebar/index.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Sidebar/scrollbar.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/pages/shop/productsList.json":
/***/ (function(module, exports) {

	module.exports = {
		"/shop/merino-round-cushion/": {
			"id": 2,
			"name": "Merino Round Cushion",
			"price": 50,
			"path": "/shop/merino-round-cushion/",
			"thumbnail": "/images/products/merino-round-cushion/06.jpg",
			"category": "home",
			"type": "round-cushion",
			"gallery": {
				"1": "/images/products/merino-round-cushion/03.jpg",
				"2": "/images/products/merino-round-cushion/01.jpg",
				"3": "/images/products/merino-round-cushion/02.jpg",
				"4": "/images/products/merino-round-cushion/04.jpg",
				"5": "/images/products/merino-round-cushion/05.jpg",
				"6": "/images/products/merino-round-cushion/06.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Round Cushion made from pure merino wool!",
				"long": "<p>Beautifully crochet round cushion will be a great addition to your living room or bedroom. Made from 100% super chunky Merino Wool. These luxury products come complete with hollowfibre filling(let us know if you want different one). Transform your sofa or bed in the most cozy place in the world by adding some cushions and bedcover from merino wool. We can guarantee that everyone in the room will stare at it!</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades, 4 basic sizes and 2 patterns to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 1000,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "16x16inches",
				"pattern": "sunshine"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"16x16inches": "0|25",
					"18x18inches": "5|35",
					"20x20inches": "10|45",
					"22x22inches": "15|55"
				},
				"pattern": {
					"sunshine": "0|0",
					"braid": "0|0"
				}
			}
		},
		"/shop/merino-chunky-blanket/": {
			"id": 3,
			"name": "Merino Chunky Blanket",
			"price": 45,
			"path": "/shop/merino-chunky-blanket/",
			"thumbnail": "/images/products/merino-chunky-blanket/06.jpg",
			"category": "home",
			"type": "blanket",
			"gallery": {
				"1": "/images/products/merino-chunky-blanket/01.jpg",
				"2": "/images/products/merino-chunky-blanket/02.jpg",
				"3": "/images/products/merino-chunky-blanket/03.jpg",
				"4": "/images/products/merino-chunky-blanket/04.jpg",
				"5": "/images/products/merino-chunky-blanket/05.jpg",
				"6": "/images/products/merino-chunky-blanket/06.jpg",
				"7": "/images/products/merino-chunky-blanket/07.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Blanket made from pure merino wool!",
				"long": "<p>A merino wool blanket is the perfect solution for warming up on cooler days, alongside a good movie, in the comfort of your home. They have a wonderful and unique look that will highlight the decoration of your home. You will find out everyone will be delighted!</p><p>The blanket is an extremely luxury and beautiful product, which will bring more style and comfort into your home. Also, it's perfect gift for any occasion. </p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades, 9 basic sizes and 3 patterns to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 5000,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "25x35inches",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"25x35inches": "0|25",
					"30x50inches": "70|165",
					"40x60inches": "105|300",
					"50x70inches": "150|375",
					"60x80inches": "200|525",
					"80x80inches": "305|660",
					"80x100inches": "500|980",
					"90x90inches": "500|980",
					"100x100inches": "680|1400"
				},
				"pattern": {
					"classic": "0|0",
					"chess": "0|0",
					"braid": "0|0",
					"striped": "0|0"
				}
			}
		},
		"/shop/merino-classic-scarf/": {
			"id": 4,
			"name": "Merino Classic Scarf",
			"price": 45,
			"path": "/shop/merino-classic-scarf/",
			"thumbnail": "/images/products/merino-classic-scarf/04.jpg",
			"category": "knitwear",
			"type": "classic-scarf",
			"gallery": {
				"1": "/images/products/merino-classic-scarf/01.jpg",
				"2": "/images/products/merino-classic-scarf/02.jpg",
				"3": "/images/products/merino-classic-scarf/03.jpg",
				"4": "/images/products/merino-classic-scarf/04.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Classic Scarf made from pure merino wool!",
				"long": "<p>100% pure merino wool, soft and warm, classic scarf. It provides such great comfort that you will be constantly hugging it! Besides it's breathable and natural. This scarf will keep you warm no matter the weather. Also, it will be a really eye catching part of your outfit! It looks great on both, a woman, and a man.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades and 6 basic sizes to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 1000,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "45x5inches",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"45x5inches": "0|10",
					"55x5inches": "5|20",
					"65x5inches": "10|30",
					"75x5inches": "15|40",
					"85x5inches": "20|50",
					"95x5inches": "25|60"
				},
				"pattern": {
					"classic": "0|0"
				}
			}
		},
		"/shop/merino-super-chunky-scarf/": {
			"id": 5,
			"name": "Merino Super Chunky Scarf",
			"price": 60,
			"path": "/shop/merino-super-chunky-scarf/",
			"thumbnail": "/images/products/merino-super-chunky-scarf/01.jpg",
			"category": "knitwear",
			"type": "super-chunky-scarf",
			"gallery": {
				"1": "/images/products/merino-super-chunky-scarf/01.jpg",
				"2": "/images/products/merino-super-chunky-scarf/02.jpg",
				"3": "/images/products/merino-super-chunky-scarf/03.jpg",
				"4": "/images/products/merino-super-chunky-scarf/04.jpg",
				"5": "/images/products/merino-super-chunky-scarf/05.jpg",
				"6": "/images/products/merino-super-chunky-scarf/06.jpg",
				"7": "/images/products/merino-super-chunky-scarf/07.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Chunky Scarf made from pure merino wool!",
				"long": "<p>Super chunky scarf made from 100% pure merino wool. It's e xtremely cozy and will keeps you warm all the time. It provides such great comfort that you will be constantly hugging it! Besides it's breathable and natural. This scarf will keep you warm no matter the weather. It also will be a really eye catching part of your outfit! It looks great on both, a woman, and a man. Great gift for your love ones.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades and 6 basic sizes to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 1000,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "45x10inches",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"45x10inches": "0|15",
					"55x10inches": "10|30",
					"65x10inches": "20|45",
					"75x10inches": "30|60",
					"85x10inches": "40|75",
					"95x10inches": "50|90"
				},
				"pattern": {
					"classic": "0|0"
				}
			}
		},
		"/shop/merino-pom-pom-beanie/": {
			"id": 6,
			"name": "Merino Pom-Pom Beanie",
			"price": 60,
			"path": "/shop/merino-pom-pom-beanie/",
			"thumbnail": "/images/products/merino-pom-pom-beanie/01.jpg",
			"category": "knitwear",
			"type": "pom-pom-beanie",
			"gallery": {
				"1": "/images/products/merino-pom-pom-beanie/01.jpg",
				"2": "/images/products/merino-pom-pom-beanie/02.jpg",
				"3": "/images/products/merino-pom-pom-beanie/03.jpg",
				"4": "/images/products/merino-pom-pom-beanie/04.jpg",
				"5": "/images/products/merino-pom-pom-beanie/05.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Pom-Pom Beanie made from pure merino wool!",
				"long": "<p>A luxurious, chunky knit handmade beanie, finished with unique pom-pom. It provides very good protection against cold, and due to its delicacy it ensures superior comfort of use. I can bet you've never wear more comfortable beanie! Make even better impression and combine it with any kind of scarf, and you will definitely be noticed!</p><p>Every beanie is tailored specially for you, so please remember to send us head measurement, or let us know if you want us to made it in 'one-size-fits-all' option.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 500,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "customized",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"customized": "0|25"
				},
				"pattern": {
					"classic": "0|0"
				}
			}
		},
		"/shop/merino-beanie/": {
			"id": 7,
			"name": "Merino Beanie",
			"price": 55,
			"path": "/shop/merino-beanie/",
			"thumbnail": "/images/products/merino-beanie/03.jpg",
			"category": "knitwear",
			"type": "beanie",
			"gallery": {
				"1": "/images/products/merino-beanie/01.jpg",
				"2": "/images/products/merino-beanie/02.jpg",
				"3": "/images/products/merino-beanie/03.jpg",
				"4": "/images/products/merino-beanie/04.jpg",
				"5": "/images/products/merino-beanie/05.jpg",
				"6": "/images/products/merino-beanie/06.jpg",
				"7": "/images/products/merino-beanie/07.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Beanie made from pure merino wool!",
				"long": "<p>Very warm, soft, cuddly and silky to the touch beanie. It provides very good protection against cold, and due to its delicacy it ensures superior comfort of use. I can bet you've never wear more comfortable beanie! It makes even better impression when combined with any kind of scarf. 100% hand knitted from one of the softest sheep yarns in the world.</p><p>Every beanie is tailored specially for you, so please remember to send us head measurement, or let us know if you want us to made it in 'one-size-fits-all' option.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 500,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "customized",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"customized": "0|25"
				},
				"pattern": {
					"classic": "0|0"
				}
			}
		},
		"/shop/merino-infinity-scarf/": {
			"id": 8,
			"name": "Merino Infinity Scarf",
			"price": 60,
			"path": "/shop/merino-infinity-scarf/",
			"thumbnail": "/images/products/merino-infinity-scarf/01.jpg",
			"category": "knitwear",
			"type": "infinity-scarf",
			"gallery": {
				"1": "/images/products/merino-infinity-scarf/01.jpg",
				"2": "/images/products/merino-infinity-scarf/02.jpg",
				"3": "/images/products/merino-infinity-scarf/03.jpg",
				"4": "/images/products/merino-infinity-scarf/04.jpg",
				"5": "/images/products/merino-infinity-scarf/05.jpg",
				"6": "/images/products/merino-infinity-scarf/06.jpg",
				"7": "/images/products/merino-infinity-scarf/07.jpg",
				"8": "/images/products/merino-infinity-scarf/08.jpg"
			},
			"tabs": {
				"0": {
					"title": "Samples",
					"content": "some samples text"
				},
				"1": {
					"title": "Extras",
					"content": "some description about available extras for this products"
				},
				"2": {
					"title": "care tips",
					"content": "how to care about products"
				}
			},
			"description": {
				"short": "Extremely soft and cozy, UK handicraft, luxury Infinity Scarf made from pure merino wool!",
				"long": "<p>Extremely soft alternative for classic scarf! Looks great on both, a woman, and a man. Handicraft from 100% pure merino wool. Super cosy statement piece that everyone will ask you about. Great gift for your love ones. You'll be miss it every time you take it off!</p><p>The infinite scarf is made in option - 'one-size-fits-all' <small>(approx. 14x10\")</small>.</p> <p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
			},
			"weight": 500,
			"preset": {
				"material": "premium",
				"color": "ecru",
				"size": "14x10inches",
				"pattern": "classic"
			},
			"variants": {
				"material": {
					"premium": 0,
					"deluxe": 0
				},
				"color": {
					"ecru": "0|0",
					"mustard": "0|0",
					"clementine": "0|0",
					"pumpkin": "0|0",
					"poppy": "0|0",
					"scarlet": "0|0",
					"elderberry": "0|0",
					"salmon": "0|0",
					"barbie": "0|0",
					"hot pink": "0|0",
					"chocolate": "0|0",
					"candyfloss": "0|0",
					"damson": "0|0",
					"lime": "0|0",
					"gooseberry": "0|0",
					"olive": "0|0",
					"moss": "0|0",
					"dream": "0|0",
					"spearmint": "0|0",
					"royal": "0|0",
					"navy": "0|0",
					"midnight": "0|0",
					"seal": "0|0",
					"grey": "0|0",
					"black": "0|0"
				},
				"size": {
					"14x10inches": "0|25"
				},
				"pattern": {
					"classic": "0|0"
				}
			}
		}
	};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"D:/projekty/Calipsy/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"D:/projekty/Calipsy/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"D:/projekty/Calipsy/node_modules/babel-preset-stage-0/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/shop.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _reactToastify = __webpack_require__("./node_modules/react-toastify/lib/index.js");
	
	var _Commons = __webpack_require__("./src/Components/Shared/Commons.js");
	
	var _ProductsList = __webpack_require__("./src/components/ProductsList/index.js");
	
	var _ProductsList2 = _interopRequireDefault(_ProductsList);
	
	var _ProductsFilters = __webpack_require__("./src/components/ProductsFilters/index.js");
	
	var _ProductsFilters2 = _interopRequireDefault(_ProductsFilters);
	
	var _Sidebar = __webpack_require__("./src/components/Sidebar/index.js");
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Newsletter = __webpack_require__("./src/components/Newsletter/index.js");
	
	var _Newsletter2 = _interopRequireDefault(_Newsletter);
	
	var _translations = __webpack_require__("./translations/index.js");
	
	var _productsList = __webpack_require__("./src/pages/shop/productsList.json");
	
	var _productsList2 = _interopRequireDefault(_productsList);
	
	var _index = __webpack_require__("./src/components/SEO/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	//---------	Plugins
	
	//---------	Components
	
	//---------	Translations
	
	//---------  Products List
	
	
	var ShopTemplate = function (_React$Component) {
	  _inherits(ShopTemplate, _React$Component);
	
	  //---------	Constructor
	  function ShopTemplate(props) {
	    _classCallCheck(this, ShopTemplate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.activeCategoriesMessage = _translations.T.shop.browsing.all;
	    _this.categories = _this.createCategoriesList(_productsList2.default);
	    _this.state = {
	      filters: [],
	      loading: true
	    };
	
	    _this.createFiltersMessage = _this.createFiltersMessage.bind(_this);
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  ShopTemplate.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ loading: false });
	    }, 300);
	    setTimeout(function () {
	      return (0, _Commons.onTemplateLoad)();
	    });
	  };
	
	  //---------	Custom functions
	
	
	  ShopTemplate.prototype.toggleSidebar = function toggleSidebar(sendToast) {
	    this.child.toggleSidebar();
	
	    if (sendToast === 'sendToast') {
	      _reactToastify.toast.info(_react2.default.createElement(
	        'div',
	        { className: 'filtersApplied info' },
	        _translations.T.global.filtersApplied
	      ), {
	        position: _reactToastify.toast.POSITION.TOP_RIGHT,
	        autoClose: 1500
	      });
	    }
	  };
	
	  ShopTemplate.prototype.callback = function callback(response) {
	    this.createFiltersMessage(response);
	    this.setState({ filters: response });
	  };
	
	  ShopTemplate.prototype.createCategoriesList = function createCategoriesList(products) {
	    var categories = [];
	
	    (0, _lodash.filter)(products, function (product) {
	      if (!(0, _lodash.includes)(categories, product.category)) {
	        categories.push(product.category);
	      }
	    });
	
	    return categories;
	  };
	
	  ShopTemplate.prototype.createFiltersMessage = function createFiltersMessage(filters) {
	    var activeCategories = (0, _lodash.filter)(this.categories, function (filter) {
	      return !(0, _lodash.includes)(filters, filter);
	    });
	
	    if (activeCategories.length === this.categories.length) {
	      this.activeCategoriesMessage = _translations.T.shop.browsing.all;
	    } else {
	      this.activeCategoriesMessage = _translations.T.shop.browsing.list + (0, _lodash.join)(activeCategories, ', ');
	    }
	  };
	
	  //---------	Render
	
	
	  ShopTemplate.prototype.render = function render() {
	    var _this3 = this;
	
	    var data = this.props.data.markdownRemark.frontmatter;
	    var seo = {
	      title: _translations.T.SEO.title.shop + ' - ' + data.title + ' | Calipsy'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper' },
	      _react2.default.createElement(_index2.default, seo),
	      _react2.default.createElement('div', { className: 'CalipsySpinner' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsyWrapper-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyShop' },
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyContainer' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                this.activeCategoriesMessage
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'CalipsyButton',
	                  onClick: this.toggleSidebar.bind(this) },
	                _translations.T.shop.messages.changeFilters
	              )
	            ),
	            _react2.default.createElement(_ProductsList2.default, { productsList: _productsList2.default, filters: this.state.filters })
	          ),
	          _react2.default.createElement(_Newsletter2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        _Sidebar2.default,
	        { onRef: function onRef(ref) {
	            return _this3.child = ref;
	          }, title: _translations.T.shop.messages.filtersTitle },
	        _react2.default.createElement(_ProductsFilters2.default, { toggleSidebar: this.toggleSidebar.bind(this), onRef: function onRef(ref) {
	            return _this3.child = ref;
	          },
	          categories: this.categories, filters: function filters(response) {
	            return _this3.callback(response);
	          } })
	      )
	    );
	  };
	
	  return ShopTemplate;
	}(_react2.default.Component);
	
	exports.default = ShopTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-shop-js-6b90c85c993b6e0bc08c.js